import Brand from '../../common/Brand';
import type { HeaderProps } from './useHeader';

const HeaderDesktop = ({
  data,
  handleNavClick,
  handleCtaClick,
}: HeaderProps) => {
  return (
    <header className="fixed top-0 z-50 w-full bg-surface-primary">
      <div className="flex items-center justify-between px-20 py-6">
        <Brand link="/" variant="dark" />

        <nav className="flex items-center gap-12">
          {data.navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className="cursor-pointer border-none bg-transparent font-body text-[15px] font-medium text-foreground-secondary transition-colors hover:text-foreground-primary"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          onClick={handleCtaClick}
          className="cursor-pointer rounded bg-accent-primary px-8 py-3.5 font-body text-sm font-semibold text-surface-inverse transition-colors hover:bg-accent-hover"
        >
          {data.ctaText}
        </button>
      </div>
    </header>
  );
};

export default HeaderDesktop;
